<template>
  <div
    class="w-full py-5 px-16 primary-color h-auto float-left shadow sticky top-0 z-50 flex max-h-16 items-center justify-center">
    <div class="message_notification">
      <i v-if="loggedIn" @click="access()" class="pi pi-bars side-menu"
        style="margin-right: 10px;margin-left: 10px;"></i>
    </div>

    <div class="flex justify-between align-middle w-full max-w-fix">
      <router-link to="/">
        <h2 class="text-white font-normal text-lg text-left w-max float-left noselect">
          {{ $t("general.snap_drive") }}
        </h2>
      </router-link>
      <div class="flex flex-row justify-between items-center gap-3">

        <div v-if="loggedIn">
          <router-link to="/profile">
            <img class="profile-img" src="./assets/profile/driver-avatar.svg" />
          </router-link>
          
        </div>

        <a v-if="loggedIn">
          <div class="spring-spinner" v-if="loggingOut">
            <div class="spring-spinner-part top">
              <div class="spring-spinner-rotator"></div>
            </div>
            <div class="spring-spinner-part bottom">
              <div class="spring-spinner-rotator"></div>
            </div>
          </div>
          <img src="./assets/icons/logout.svg" @click="logout" v-else />
        </a>

        <LangSelector />
      </div>
    </div>
  </div>
  <Sidebar v-model:visible="visibleLeft" :position="$store.getters.selectedLanguage === 'ar' ? 'right' : 'left'"
    dismissable :showCloseIcon="false" style="padding: 0">
    <PanelMenu class="test" header="Header" :model="items" />
  </Sidebar>
  <router-view />
  <Dialog />
  <notifications position="bottom left" max="10" class="notification" closeOnClick="true" />
</template>

<script>
import LangSelector from "./components/LangSelector.vue";
import { onMounted, onUnmounted } from "vue";
import axios from "axios";
import Dialog from "@/components/Dialog.vue";
import Sidebar from "primevue/sidebar";
import "primeicons/primeicons.css";
import PanelMenu from "primevue/panelmenu";
import socketEventsMixin from "@/mixins/socketEventsMixin";


export default {
  name: "App",
  mixins: [socketEventsMixin],
  events() {
    return {

      "Passengers:three_ds_new": this.three_ds,
    };
  },
  components: {
    LangSelector,
    Dialog,
    Sidebar,
    PanelMenu,
  },
  computed: {
    items() {
      let itms = [];
      // The legacy guest "place order" page is a super-admin-controlled feature
      // per establishment (guest_form_enabled); hide it otherwise.
      if (this.guestFormEnabled) {
        itms.push({
          label: this.$t("general.place_order"),
          icon: "pi pi-phone",
          command: () => {
            this.$router.push("/");
            this.visibleLeft = false;
          },
        });
      }
      itms.push(
        {
          label: this.$t('business.team_title'),
          icon: "pi pi-users",
          command: () => {
            this.$router.push("/business-team");
            this.visibleLeft = false;
          },
        },
        {
          label: this.$t('business.trip_log_title'),
          icon: "pi pi-list",
          command: () => {
            this.$router.push("/business-trips");
            this.visibleLeft = false;
          },
        },
        {
          label: this.$t('general.upcoming_orders'),
          icon: "pi pi-clock",
          command: () => {
            this.$router.push("/upcoming-orders");
            this.visibleLeft = false;
          },
        },
        {
          label: this.$t('general.order_history'),
          icon: "pi pi-clock",
          command: () => {
            this.$router.push("/order-history");
            this.visibleLeft = false;
          },
        },
        {
          label: this.$t('business.account'),
          icon: "pi pi-wallet",
          command: () => {
            this.$router.push("/business-account");
            this.visibleLeft = false;
          },
        }
      );

      return itms;
    },

  },
  data(vm) {
    return {
      loggedIn: false,
      loggingOut: false,
      visibleLeft: false,
      booking: null,
      // Whether this establishment may use the legacy guest order form (set by
      // the super admin). Hidden until confirmed so clean-start establishments
      // do not flash the guest page.
      guestFormEnabled: false,
    };
  },
  beforeMount() {
    this.loggedIn = this.$store.getters.loggedIn;
    document.addEventListener("keydown", function (e) {
      if (e.which === 38 || e.which === 40) {
        e.preventDefault();
      }
    });
    if (this.loggedIn)
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$store.state.token;
    this.$i18n.locale = this.$store.getters.selectedLanguage;
  },
  mounted() {
    if (this.loggedIn) this.loadBusinessFlags();
  },

  watch: {
    "$store.getters.loggedIn": {
      handler: function (val) {
        this.loggedIn = val;
        if (val) this.loadBusinessFlags();
      },
      immediate: true,
    },
    '$store.getters.selectedLanguage': {
      immediate: true,
      handler(lang) {
        document.documentElement.setAttribute(
          "dir",
          lang === "ar" ? "rtl" : "ltr"
        );

      }
    }

  },
  methods: {

    // Fetch this establishment's flags (guest_form_enabled). Guarded on the auth
    // header so it never fires before login has set it.
    loadBusinessFlags() {
      if (!axios.defaults.headers.common["Authorization"]) return;
      axios
        .get(this.$store.getters.getRootAPI + "business-account")
        .then((r) => {
          const a = r.data && r.data.data ? r.data.data : {};
          this.guestFormEnabled = !!a.guest_form_enabled;
          // Clean-start establishments land on the team page, not the guest form.
          if (!this.guestFormEnabled && this.$route && this.$route.path === "/") {
            this.$router.push("/business-team");
          }
        })
        .catch(() => {});
    },

    access() {
      this.visibleLeft = true;
    },

    logout() {
      this.loggingOut = true;
      this.$store
        .dispatch("destroyToken")
        .then(() => {
          console.log("done3");
          this.$router.push({ name: "Login" });
          this.loggingOut = false;
          this.loggedIn = false;
        })
        .catch(() => {
          this.loggingOut = false;
          this.loggedIn = true;
        });
    },

  },
};
</script>

<style lang="scss" scoped>
a {
  cursor: pointer;
}

.side-menu {
  color: white;
  margin-right: 5px;
}

.side-menu {
  cursor: pointer;
}

.message-text {
  font-size: 16px;
}

.parent-div {
  position: relative;
  display: inline-block;
}

.primary-color {
  background-color: #27a432;
}

.notification-circle {
  position: absolute;
  display: inline-block;
  top: -7px;
  right: -8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: red;
  text-align: center;
  color: white;
  font-size: 12px;
  /* Adjust font size as needed */
  line-height: 20px;
  /* Vertically align the number */
}

.profile-img {
  width: 30px;
  border-radius: 30px;
  height: 30px;
}
</style>
